import { render, staticRenderFns } from "./productionPanelBreakdownWidget.vue?vue&type=template&id=6e48bd80&"
import script from "./productionPanelBreakdownWidget.vue?vue&type=script&lang=js&"
export * from "./productionPanelBreakdownWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports